import React from "react";

export interface TabItem {
  id: string;
  label: string;
  icon?: React.ComponentType<{ className?: string }>;
}

interface TabsProps {
  items: TabItem[];
  selectedId: string;
  onChange: (id: string) => void;
  className?: string;
}

export const Tabs: React.FC<TabsProps> = ({
  items,
  selectedId,
  onChange,
  className = "",
}) => {
  return (
    <div className={`flex justify-center ${className}`}>
      <div className="inline-flex bg-slate-100 dark:bg-slate-800/50 p-1.5 rounded-full gap-1 overflow-x-auto max-w-full">
        {items.map((item) => {
          const Icon = item.icon;
          const isSelected = selectedId === item.id;
          return (
            <button
              key={item.id}
              onClick={() => onChange(item.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap
                ${
                  isSelected
                    ? "bg-white dark:bg-slate-700 text-indigo-600 dark:text-indigo-400 shadow-sm ring-1 ring-slate-200 dark:ring-slate-600"
                    : "text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-white/50 dark:hover:bg-slate-700/50"
                }`}
            >
              {Icon && (
                <Icon
                  className={`w-4 h-4 ${
                    isSelected ? "text-indigo-600 dark:text-indigo-400" : ""
                  }`}
                />
              )}
              {item.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Tabs;
